import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { ReactSVG } from "react-svg";
import { motion, AnimatePresence } from "framer-motion";
import ProductCartItem from '../ProductCartItem/ProductCartItem.js';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import i18n from "../../i18n/i18n.js";
import { Utils } from '../../Utils.js';
import CheckoutSummary from '../../components/CheckoutSummary/CheckoutSummary.js';

import { useAppContext, useModalsContext, withAppContext } from '../../contexts/AppContext';
import './Minicart.css';
import { Link } from 'react-router-dom';
import { i, tr } from 'framer-motion/client';

const Minicart = (props) => {
  const appContext = useAppContext();
  const appRef = appContext.appRef.current;
  const modalsContext = useModalsContext();

  const [isOpen, setIsOpen] = useState(props.isCheckout || false);
  const minicartRef = useRef(null);

  const [shoppingCart, setShoppingCart] = useState(appRef.state.shopping_cart || {});
  const [itemCount, setItemCount] = useState(shoppingCart.pc_sum || 0);

  useEffect(() => {
    const handleCartUpdate = (e) => {
      const cart = e.detail || appRef.state.shopping_cart || {};
      setShoppingCart(cart);
      setItemCount(cart.pc_sum || 0);
    };

    // Kezdeti beállítás az aktuális stateből
    if (appRef.state.shopping_cart) {
      setShoppingCart(appRef.state.shopping_cart);
      setItemCount(appRef.state.shopping_cart.pc_sum || 0);
    }

    window.addEventListener('shopping_cart_updated', handleCartUpdate);
    return () => {
      window.removeEventListener('shopping_cart_updated', handleCartUpdate);
    };
  }, []);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const closeMinicart = () => {
    setIsOpen(false);
  };

  const showCouponModal = () => {

    const CouponModalContent = () => {

      const [inputValue, setInputValue] = useState(shoppingCart.coupon_code || '');
      
      const handleApplyCoupon = () => {
        appRef.closeDialog();
        Utils.get_update_shopping_cart({
          select_coupon: inputValue
        });
      };

      return (
        <div className='coupon-modal-content'>
          <button className='modal-close-btn' onClick={() => appRef.closeDialog()}>
            <ReactSVG src="/assets/images/close.svg" />
          </button>
          <div className='coupon-modal-title'>{i18n.t('couponModalTitle')}</div>
          <div className='coupon-modal-input'>
            <input 
              type='text' 
              name='select_coupon' 
              placeholder={i18n.t('couponModalPlaceholder')}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </div>
          <div className='coupon-modal-buttons'>
            <button className='apply-btn' onClick={handleApplyCoupon}>{i18n.t('couponModalApplyBtn')}</button>
          </div>
        </div>
      );
    };

    appRef.set_dialog_message(<CouponModalContent />, { cancel: true, hide_buttons: true });
  };

  function on_change_product(product,event) {
    
    if(event==='favorite_remove' || event==='favorite_add'){
      
      if(event==='favorite_remove'){
        appRef.product_fav_delete(null,{product});
      }else if(event==='favorite_add'){
        appRef.product_fav_add(null,{product});
      }

      return;
    }

    const order_id = shoppingCart.order_id;
    const coupon_code = shoppingCart.coupon_code ?? '';

    setShoppingCart((prevCart) => {
      const cart_copy = { ...prevCart };
      const products = Array.isArray(cart_copy.products) ? [...cart_copy.products] : [];
      const productId = parseInt(product.id);

      if (product.pc === 0 || event === 'delete') {
        cart_copy.products = products.filter((item) => parseInt(item.id) !== productId);
      } else {
        cart_copy.products = products.map((item) => {
          if (parseInt(item.id) === productId) {
            return { ...item, pc: parseInt(product.pc) };
          }
          return item;
        });
      }

      cart_copy.pc_sum = (cart_copy.products || []).reduce((sum, item) => sum + (parseInt(item.pc) || 0), 0);
      setItemCount(cart_copy.pc_sum || 0);

      return cart_copy;
    });

    //const loyalti_data = this.create_loaylty_data_from_state();
    const loyalti_data = '';
    
    if(product.pc===0 || event==='delete'){
      Utils.shopping_cart_delete(product,order_id,coupon_code,loyalti_data);
    }else if(product.pc>0){
      Utils.shopping_cart_modify(product,order_id,coupon_code,loyalti_data);
    }    

  }

  const renderCartContent = () => {
    if (shoppingCart.pc_sum > 0) {
      return (
        <>
          {shoppingCart.delivery_infobox?.logistic_cost_text && <div className='delivery_info' dangerouslySetInnerHTML={{__html:shoppingCart.delivery_infobox.logistic_cost_text}}></div>}
          {shoppingCart.delivery_infobox?.main_text && <div className='delivery_info' dangerouslySetInnerHTML={{__html:shoppingCart.delivery_infobox.main_text}}></div>}
          <div className='minicart-items'>
            {shoppingCart.products && shoppingCart.products.map((item) => (
              <ProductCartItem isCheckout={props.isCheckout}  key={item.id} product={item} select_quantity={true} on_change_product={on_change_product} />
            ))}
          </div>
          <div className='minicart-coupon-row'>
            {!shoppingCart?.discounts?.coupon_system?.active ?
              <div className='apply-coupon'>
                 <div className='coupon-with-label'>
                  <ReactSVG src="/assets/images/coupon.svg" /> {i18n.t('shoppingCartApplyCoupon')}
                 </div>
                 <div className='apply-coupon-button'>
                   <button onClick={showCouponModal}>{i18n.t('shoppingCartApplyCouponBtn')}</button>
                 </div>
              </div>
            :
              <div className='applyed-coupon'>
                <div className='coupon-with-label'>
                  <div className='coupon-name'>
                    <ReactSVG src="/assets/images/coupon.svg" /> 
                    <span>{shoppingCart?.discounts?.coupon_system?.coupon_number}</span>
                    <span className="couponGross" dangerouslySetInnerHTML={{__html: "-"+shoppingCart?.discounts?.coupon_system?.coupon_gross}}></span>
                  </div>
                  <div className='coupon-description'>{shoppingCart?.discounts?.coupon_system?.coupon_label}</div>
                </div>
                <div className='delete-coupon-button'>
                  <button onClick={() => Utils.get_update_shopping_cart({delete_coupon: '1'})}>
                    <ReactSVG src="/assets/images/close.svg" />
                  </button>
                </div>
              </div>
            }
            {shoppingCart?.discounts?.coupon_system?.coupon_errors && (
              <div className='coupon-error-message'>{shoppingCart?.discounts?.coupon_system?.coupon_errors}</div>
            )}
          </div>
          <div className='minicart-totals'>
            <div className='totals-row'>
              <span>{i18n.t('shoppingCartSubtotalNet')}</span>
              <span dangerouslySetInnerHTML={{__html:shoppingCart.sum_total_net}}></span>
            </div>
            <div className='totals-row'>
              <span>{i18n.t('shoppingCartSubtotalGross')}</span>
              <span dangerouslySetInnerHTML={{__html:shoppingCart.sum_total_gross}}></span>
            </div>
          </div>
          {parseInt(shoppingCart.loyalty_points_value)>0 &&
          <div className='loyalty-points-info'>
            <p>{i18n.t('shoppingCartLoyaltyPointsValue', {value: shoppingCart.loyalty_points_value})}</p>
          </div>
          }
          {!props.isCheckout && (
            <div className='cart-actions'>
              <Link to="/checkout" data-type="in-app" onClick={toggle} className="start-checkout-btn">
                  {i18n.t('minicartStartCheckout')}
              </Link>
            </div>
          )}
          
          {props.isCheckout ?
            <CheckoutSummary isEmbedded={true} onClose={closeMinicart} />
           : ''}
        </>
      );
    } else {
      return (
        <div className='minicart-empty'>
          <p>{i18n.t('shoppingCartEmpty')}</p>
          {!props.isCheckout && (
            <button onClick={toggle} className="btn btn-primary">{i18n.t('shopNowButton')}</button>
          )}
        </div>
      );
    }
  };

  return (
    <div
      ref={minicartRef}
      className={`minicart-container${isOpen ? ' open' : ''}`}
    >
      {!props.isCheckout && (
        <div className='minicart-icon' onClick={toggle}>
          <ReactSVG src="/assets/images/basket.svg" />
          <span className='minicart-count'>{itemCount}</span>
        </div>
      )}
      {props.isCheckout ? (
        <div className='minicart-checkout-content'>
          {renderCartContent()}
        </div>
      ) : (
        ReactDOM.createPortal(
          <AnimatePresence>
            {isOpen && (
              <motion.div
                className="container floating_container minicart_container"
                initial={{ x: "100%" }}
                animate={{ x: 0 }}
                exit={{ x: "100%" }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
              >
                <div className={`floating_container_inner`}>
                  <div className='floating_container_header'>
                    <PageHeader isHistoryBack={false} no_back={true} title={i18n.t('shoppingCartTitle', { count: itemCount })} callback={toggle}></PageHeader>
                  </div>
                  
                  <div className='floating_container_content'>
                    {renderCartContent()}
                  </div>

                </div>
              </motion.div>
            )}
          </AnimatePresence>, document.querySelector('.application_wrapper')
        )
      )}
    </div>
  );
};

export default withAppContext(Minicart);
